/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2WarningIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Tysiav2WarningIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2WarningIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#BA2525"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2WarningIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-yyytc': alignSelf,'--mt-2-yyytc': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-yyytc': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-yyytc': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-yyytc': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-yyytc': opacity,'--w-10-yyytc': typeof width === 'number' ? `${width}px` : width,'--h-11-yyytc': typeof height === 'number' ? `${height}px` : height,'--f-12-yyytc': fill,'--a-7-yyytc': isAnimated ? animation : "none",'--sd-8-yyytc': isAnimated ? strokeDashoffset : 0,'--sd-9-yyytc': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2WarningIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M10 17a7 7 0 100-14 7 7 0 000 14zm0-10.875a.75.75 0 01.75.75v3.25a.75.75 0 01-1.5 0v-3.25a.75.75 0 01.75-.75zm1 6.75a1 1 0 11-2 0 1 1 0 012 0z"
 style={{'--f-12-yyytc': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}